import './App.css';
import React from 'react';
import MenuBar from './components/menu-bar/menu-bar';
import CameraPanel from './components/stage/camera-panel';
import CodingArea from './components/coding-area/coding-area';
import bindAll from "lodash.bindall";
import BLEWrapper from './communication-manager/ble';
import WEBSocket from './communication-manager/webSocket';
import WEBcam from './communication-manager/webcam';
import {updateBoard,updateConnectionStatus} from "../src/redux/codingAreaState.js";
import { enableCamera,
  disableCamera,
  boardConnected,
  boardDisconnected} from "../src/redux/menuBarState";
import { connect } from 'react-redux';
// import WebWorker from "./workerSetup";
class App extends React.Component{

  constructor(props){
      super(props);
      this.bleInstance = new BLEWrapper(this);
      this.webSocketClient = new WEBSocket(this);
      this.webCamInstance = new WEBcam(this);
      bindAll(this,[
        "boardConnectionHandler",
        "webCamConnectionHandler",
        "setCurrentBoard",
        "connectionHandler",
        "updateVideoStream"
      ]);
  }
  //From Websocket
  connectionHandler(status)
  {
    //Updates connection with PictoBlox through websocket...
    this.props.updateConnectionStatus(status)
  }
  setCurrentBoard(board){
    //Sets the board from PictoBlox
    this.props.updateBoard(board);
  }
  //From BLE
  updateBoardConnectionStatus(isConnected){
    //Updates if the board is connected or not...
    if(isConnected)
    this.props.boardConnected();
    else
    this.props.boardDisconnected();
  }
  //For menu-bar
  boardConnectionHandler()
  {
    this.bleInstance.scan();
  }
  webCamConnectionHandler(action){
    if(action=="enable")
    this.webCamInstance.enableCamera();
    else
    this.webCamInstance.disableCamera();
  }
  updateVideoStream(stream){
    // console.log(stream);
  }
  render(){
      return (
        <div className="App">
              <MenuBar
                boardConnectionHandler = {this.boardConnectionHandler}
                webCamConnectionHandler = {this.webCamConnectionHandler}
              />
              <CodingArea />
              <CameraPanel/>
        </div>
      )
  }
} 
const mapStateToProps = state =>{
  
}
const mapDispatchToProps = dispatch =>{
  return {
    updateConnectionStatus: (status) => dispatch(updateConnectionStatus(status)),
    updateBoard: (boardName) => dispatch(updateBoard(boardName)),
    boardConnected: () => dispatch(boardConnected()),
    boardDisconnected: () => dispatch(boardDisconnected()),
    disableCamera: () => dispatch(disableCamera()),
    enableCamera: () => dispatch(enableCamera())
  }
}

export default connect(null,mapDispatchToProps)(App);
